"use client";

import { useEffect } from "react";
import LeaderboardContents from "@/components/LeaderboardContents";

interface LeaderboardPanelProps {
  open: boolean;
  onClose: () => void;
}

// A compact, in-place leaderboard that drops down from the top-right over the
// wheel — no separate page, so the run is never interrupted and the music
// keeps playing. Mounts/unmounts with `open` so its scores refetch each time
// it's opened.
export default function LeaderboardPanel({
  open,
  onClose,
}: LeaderboardPanelProps) {
  // Close on Escape for quick dismissal.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="animate-slide-down fixed right-4 top-16 z-50 flex max-h-[min(80vh,38rem)] w-[min(94vw,28rem)] flex-col overflow-hidden rounded-2xl border border-accent/40 bg-background/95 shadow-[0_0_50px_rgba(0,0,0,0.7)] backdrop-blur">
      <div className="flex shrink-0 items-center justify-between border-b border-white/10 px-4 py-3">
        <h3 className="text-sm font-extrabold uppercase tracking-widest text-white">
          Leaderboard
        </h3>
        <button
          onClick={onClose}
          aria-label="Close leaderboard"
          className="flex h-7 w-7 items-center justify-center rounded-full border border-white/20 text-white/60 transition hover:border-accent hover:text-accent"
        >
          ✕
        </button>
      </div>

      <LeaderboardContents maxEntries={10} />
    </div>
  );
}
